{
  "dates-and-configuration": "Fechas y Configuración",
  "type": "Tipo",
  "transaction-types": "Tipos de Transaccion",
  "closing-date": "Fecha de Cierre",
  "acceptance-date": "Fecha de Aceptacion",
  "estimated-closing-date": "Fecha Estimada de Cierre",
  "founding-date": "Fecha de Fundación",
  "contract-date": "Fecha de Contrato",
  "disbursement-date": "Fecha de Desembolso",
  "amounts": "Cantidades",
  "purchase-prices": "Precios de Compra",
  "loan-amounts": "Montos de Préstamo",
  "purchase-price": "Precio Total de Compra",
  "load-amount": "Monto Total del Préstamo",
  "heloc": "Heloc",
  "place-of-closing": "Lugar de Cierre",
  "address": "Dirección",
  "state": "Estado",
  "city": "Ciudad",
  "county": "Condado",
  "configuration": "Configuración",
  "workflow": "Flujo de Trabajo",
  "status": "Estado",
  "statusHelperText": "Aviso: No se permitirán más actualizaciones una vez que el estado se establezca en \"Cerrado\".",
  "addressesTakenFrom": "Direcciones tomadas de: {{name}}",
  "additionalFeesLetter": "Letra de Cargos Adicionales",
  "additionalFees": "Cargos Adicionales"
}
